import React from "react";
import Game from "./Page/Game";

function App() {
  return (
    <>
        <Game/> 
        <br>
        </br>
        <br>
        </br><br>
        </br>
        <p>developed by Moovendhan R</p>
    </>
  );
}

export default App;
